import React, { useState } from "react";
import { MapPin, Download } from "lucide-react";
import logo from "./assets/ONA.pdf.png";

export default function App() {
  const [open, setOpen] = useState(false);

  const linkStyle = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "11px 20px",
    borderRadius: "14px",
    background: "rgba(255,255,255,0.85)",
    border: "1px solid rgba(0,0,0,0.07)",
    textDecoration: "none",
    color: "#1a1a1a",
    transition: "all 0.2s ease",
    cursor: "pointer",
  };

  const handleEnter = (e) => {
    e.currentTarget.style.background = "#1a1a1a";
    e.currentTarget.style.color = "#ffffff";
    e.currentTarget.style.transform = "scale(1.03)";
  };

  const handleLeave = (e) => {
    e.currentTarget.style.background = "rgba(255,255,255,0.85)";
    e.currentTarget.style.color = "#1a1a1a";
    e.currentTarget.style.transform = "scale(1)";
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center relative overflow-hidden"
      style={{ backgroundColor: "#8b1f41" }}
    >
      {/* Background dot pattern */}
      <div />

      {/* Center content */}
      <div className="z-10 flex flex-col items-center gap-8">

        {/* Logo */}
        <div className="text-center">
         <img
  src={logo}
  alt="Logo"
  onClick={() => setOpen(true)}
  className="w-44 md:w-56 mx-auto cursor-pointer transition duration-300 hover:scale-105"
/>
        
        </div>

        {/* Frosted card with Instagram + Location */}
        <div
          style={{
            background: "rgba(255,255,255,0.55)",
            backdropFilter: "blur(16px)",
            WebkitBackdropFilter: "blur(16px)",
            border: "1px solid rgba(255,255,255,0.95)",
            borderRadius: "22px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
            padding: "7px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          {/* Instagram */}
          <a
            href="https://www.instagram.com/ona.dubai?igsh=M2Rxb3VqOHZzbHIy"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
            onMouseEnter={handleEnter}
            onMouseLeave={handleLeave}
          >
            <img
              src="/instagram.png"
              alt="Instagram"
              style={{ width: "42px", height: "29px", objectFit: "contain" }}
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "inline-block";
              }}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="39" height="25"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ display: "none" }}
            >
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
              <circle cx="12" cy="12" r="4" />
              <circle cx="17.5" cy="6.5" r="0.8" fill="currentColor" stroke="none" />
            </svg>
            <span style={{ fontSize: "13px", fontWeight: 500, letterSpacing: "0.03em", whiteSpace: "nowrap" }}>
              Ona Coffee
            </span>
          </a>

          {/* Divider */}
          <div style={{ width: "1px", alignSelf: "stretch", background: "rgba(0,0,0,0.09)", margin: "6px 0" }} />

          {/* Location */}
          <a
            href="https://maps.app.goo.gl/p5Fzu1xsknDisM917?g_st=ic"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
            onMouseEnter={handleEnter}
            onMouseLeave={handleLeave}
          >
            <MapPin size={27} />
            <span style={{ fontSize: "13px", fontWeight: 500, letterSpacing: "0.03em", whiteSpace: "nowrap" }}>
              Dubai, UAE
            </span>
          </a>
        </div>

      </div>

      {/* Popup */}
      {open && (
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center z-20 px-4">
          <div className="bg-white rounded-3xl p-8 max-w-md w-full shadow-2xl text-center">
            

            

       

            <div className="bg-gray-100 rounded-2xl py-5 px-6 mb-6">
              <div className="flex items-center justify-center gap-2 text-gray-700">
                <MapPin size={18} />
                <span>Location Code</span>
              </div>
              <p className="text-2xl font-bold tracking-[5px] mt-2">
                67G5+HW Dubai
              </p>
            </div>

            

            <button
              onClick={() => setOpen(false)}
              className="mt-5 text-sm text-gray-500 hover:text-black"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}